module.exports = __webpack_public_path__ + "media/conversa/LogoSofia_-c27450bf.png";